<!--  -->
<template>
  <div v-loading="loading" class="edit_box">
    <div style="display: flex;margin-bottom: 20px;color: #F56C6C;">
      <div style="width: 80px; text-align: right;">*</div>
      <div>消息创建之后只存在30分钟</div>
    </div>
    <div class="onebox" style="margin-bottom: 20px;">
      <div style="width: 80px; text-align: right;">标题：</div>
      <el-input v-model.trim="title" placeholder="请输入标题" style="width: 400px" />
    </div>
    <div class="onebox" style="margin-bottom: 20px;">
      <div style="width: 80px; text-align: right">目标员工：</div>
      <el-input v-model.trim="target_employee_no" placeholder="请输入发送目标员工" style="width: 400px" />
    </div>
    <!-- <div class="onebox" style="margin: 10px 0px; display: flex; align-items: center">
      <div style="width: 80px; text-align: right">内容：</div>
      <el-input v-model="content" style="width: 400px" type="textarea" :rows="8" placeholder="请输入内消息文本内容" @blur="contneer" />
    </div> -->
    <!-- <div style="display: flex; align-items: center">
      <div style="margin-left: 10px; margin-right: 3px">随机内容:</div>
      <el-radio-group v-model="rand_title" size="medium" @change="changewrrr">
        <el-radio-button :label="1">随机</el-radio-button>
        <el-radio-button :label="0">不随机</el-radio-button>
      </el-radio-group>
    </div> -->
    <div v-if="title_options.length !== 0 && rand_title == 1" style="margin-left: 80px; margin-top: 10px; height: 270px; overflow: auto">
      <div v-for="(itemq, indexq) in title_options" :key="indexq">
        <el-input v-model.trim="title_options[indexq]" type="textarea" :rows="5" style="width: 500px; margin-bottom: 10px" placeholder="请输入内容" />
        <el-button type="danger" size="mini" style="margin-left: 10px" @click="deater(indexq)">删除</el-button>
      </div>
    </div>
    <div class="onebox" style="margin: 10px 0px">
      <div>发送类型：</div>
      <el-radio-group v-model="push_method" @change="sendcahaer">
        <el-radio-button :label="1">官方接口</el-radio-button>
        <!-- <el-radio-button :label="2" :disabled="type === 2">第三方接口</el-radio-button> -->
        <!-- <el-radio-button :label="3" :disabled="type === 2">企微脚本</el-radio-button> -->
      </el-radio-group>
    </div>
    <div class="onebox">
      <div class="all_box">
        <el-button type="success" icon="el-icon-plus" class="add-btn" size="small" @click="add">添加附件</el-button>
        <div v-for="(item, index) in attachments" :key="index" class="item-cell-box">
          <div class="search_box">
            附件{{ index + 1 }}:
            <el-radio-group v-model="item.msgtype" size="small" @change="dialogtype(item.msgtype, index)">
              <!-- <el-radio-button :label="'image'">图片</el-radio-button>
              <el-radio-button :label="'link'">图文</el-radio-button> -->
              <!-- push_method === 2 || type == 2 -->
              <el-radio-button :label="'miniprogram'">官方小程序</el-radio-button>
              <!-- <el-radio-button :label="'sp_miniprogram'" :disabled="push_method === 1">第三方小程序</el-radio-button> -->
            </el-radio-group>
            <!-- v-if="push_method != 1 || type != 2 || item.msgtype !='miniprogram'" -->
            <el-button type="warning" style="margin-left: 10px" size="small" icon="el-icon-edit-outline" @click="dialogtyper(item.msgtype, index)">编辑附件</el-button>
            <el-button type="danger" style="margin-left: 10px" icon="el-icon-delete" size="small" @click="deleter(index)">删除附件</el-button>
            <!-- <el-button v-if="attachments.length!=9 && index === 0" type="success" icon="el-icon-plus" style="margin-left:10px" size="small" @click="add(item)">添加附件</el-button> -->
          </div>
          <div v-if="item.msgtype === 'image'">
            99
            <img v-if="item.msgtype === 'image' && item.image && item.image.source_material_id !== '' && item.image.source_material_id !== null" :src="item.image.pic_url" style="width: 80px; height: 80px; margin: 10px 0px 0px 44px">
            <div v-else @click="dialogtyper(item.msgtype, index)">
              <div class="avatar-uploader">
                <i class="el-icon-plus avatar-uploader-icon" />
              </div>
            </div>
          </div>
          <div v-if="item.msgtype === 'link'" style="display: flex">
            <div v-if="item.msgtype === 'link' && item.link && item.link.title !== '' && item.link.title !== null" class="within_box">
              <div class="title_boxr">{{ item.link.title }}</div>
              <div class="imaetext se_top">
                <div class="describe_text">{{ item.link.desc }}</div>
                <div>
                  <img v-if="item.link.picurl" style="width: 50px; height: 50px; object-fit: contain" :src="item.link.picurl">
                </div>
              </div>
            </div>
            <div v-if="item.msgtype === 'link' && item.link && item.link.title !== '' && item.link.title !== null" style="position: relative; display: inline-block">
              <div style="display: flex; margin-top: 20px; align-items: center">
                <div style="margin-left: 10px">随机标题：</div>
                <!-- <el-radio-group v-model="item.link.rand_title" size="mini" @change="changewr(item)">
                  <el-radio-button :label="1">随机</el-radio-button>
                  <el-radio-button :label="0">不随机</el-radio-button>
                </el-radio-group> -->
                <div v-if="item.link.title_options.length !== 0" style="margin-left: 10px">
                  <el-tag v-for="(itemr, indexr) in item.link.title_options" :key="indexr" style="margin-right: 10px">{{ itemr }}</el-tag>
                </div>
              </div>
              <div style="display: flex; margin-top: 20px; align-items: center">
                <div style="margin-left: 10px">随机描述：</div>
                <!-- <el-radio-group v-model="item.link.rand_desc" size="mini" @change="changewrr(item)">
                  <el-radio-button :label="1">随机</el-radio-button>
                  <el-radio-button :label="0">不随机</el-radio-button>
                </el-radio-group> -->
                <div v-if="item.link.desc_options.length !== 0" style="margin-left: 10px">
                  <el-tag v-for="(itemrr, indexrr) in item.link.desc_options" :key="indexrr" style="margin-right: 10px">{{ itemrr }}</el-tag>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.msgtype === 'miniprogram'">
            <div v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.title !== '' && item.miniprogram.title !== null">
              <div class="mincard">
                <div style="display: flex; align-items: center">
                  <img v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.weappiconurl !== '' && item.miniprogram.weappiconurl !== null" :src="item.miniprogram.weappiconurl" style="width: 25px; border-radius: 50%">
                  <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width: 25px; border-radius: 50%" alt="">
                  <div class="mincard_title" style="margin: 0px 0px 0px 5px">{{ item.miniprogram.des_1 }}</div>
                </div>
                <div class="mincard_enjoy">{{ item.miniprogram.title }}</div>
                <div class="mincard_title">{{ find(item.miniprogram.app_id) }}</div>
                <div>
                  <!-- <img v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.pic_media_src!=='' && item.miniprogram.pic_media_src!==null" :src="item.miniprogram.pic_media_src" class="imgrbox"> -->
                  <img v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.thumburl !== '' && item.miniprogram.thumburl !== null" :src="item.miniprogram.thumburl" class="imgrbox">
                </div>
                <div class="line" />
                <div class="bottomwr">
                  <!-- <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px"> -->
                  <!-- <div class="weadar">小程序</div> -->
                  <el-tag size="mini">{{ item.miniprogram.miniprogram_no }}</el-tag>
                  <!-- <div class="weadar">{{ item.miniprogram.miniprogram_no }}</div> -->
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.msgtype === 'sp_miniprogram'">
            <div v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.title !== '' && item.sp_miniprogram.title !== null">
              <div class="mincard">
                <div style="display: flex; align-items: center">
                  <img v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.weappiconurl !== '' && item.sp_miniprogram.weappiconurl !== null" :src="item.sp_miniprogram.weappiconurl" style="width: 25px; border-radius: 50%">
                  <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width: 25px; border-radius: 50%" alt="">
                  <div class="mincard_title" style="margin: 0px 0px 0px 5px">{{ item.sp_miniprogram.des_1 }}</div>
                </div>
                <div class="mincard_enjoy">{{ item.sp_miniprogram.title }}</div>
                <div>
                  <img v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.thumburl !== '' && item.sp_miniprogram.thumburl !== null" :src="item.sp_miniprogram.thumburl" class="imgrbox">
                </div>
                <div class="line" />
                <div class="bottomwr">
                  <!-- <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                  <div class="weadar">小程序</div> -->
                  <el-tag size="mini">{{ item.sp_miniprogram.miniprogram_no }}</el-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div><el-button type="primary" class="confirm-button" @click="onclick">确定</el-button></div>

    <!-- 上传图片弹窗 -->
    <el-dialog title="图片库" :visible.sync="dialogVisibletwo" :close-on-click-modal="false" width="50%" append-to-body>
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
    <!-- 图文弹窗 -->
    <el-dialog title="选择图文" :visible.sync="dialogVisibletu" :close-on-click-modal="false" width="800px" append-to-body :destroy-on-close="true">
      <edittuwen ref="tuwenview" @callback="callback" />
    </el-dialog>
    <!-- 小程序弹窗 -->
    <el-dialog title="选择官方小程序" :visible.sync="dialogVisiblewechat" :close-on-click-modal="false" width="70%" append-to-body :destroy-on-close="true">
      <wecaht ref="wecahtview" @callwechat="callwechat" />
    </el-dialog>
    <!-- 小程序弹窗 -->
    <el-dialog title="选择第三方小程序" :visible.sync="dialogVisiblewecaht" width="70%" append-to-body :close-on-click-modal="false" :destroy-on-close="true">
      <wechat ref="wechatview" @wechatcallback="wechatcallback" />
    </el-dialog>
  </div>
</template>
<script>
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
// import chooseimg from '../menumanagement/components/chooseimg.vue'
import { rwematerialTaskcreate, rwematerialTaskupdate, sprEnterprise, getMultiTitles } from '@/api/officialaccount.js'
import { mptypeslist } from '@/api/sourceMaterial.js'
import edittuwen from '../../enterpmessagelist/components/edittuwen.vue'
// import wecaht from './components/wecaht.vue'
import wecaht from '../../enterpmessagelist/components/wechat------.vue'
import wechat from '../../enterpriseAstaff/components/wechat.vue'
export default {
  components: { chooseimg, edittuwen, wecaht, wechat },
  data() {
    return {
      radio: '',
      content: '', // 内容
      content0: '',
      title: '', // 标题
      rand_title: 1,
      title_options: [],
      attachments: [
        // { // 数据数组
        // msgtype: ''
        // image: {
        //   source_material_id: '',
        //   pic_url: ''
        // }
        //   "link": {
        // 	"title": "消息标题",
        // 	"picurl": "https://example.pic.com/path",
        // 	"desc": "消息描述",
        // 	"url": "https://example.link.com/path"
        // }
        // }
      ],
      dialogVisibletwo: false, // 图片库弹窗
      dialogVisibletu: false, // 图文的弹窗
      dialogVisiblewechat: false, // 小程序的弹窗
      activetype: '', // 类型
      activeindex: null, // 选择的索引
      type: null, // 新增还是编辑类型
      sp_message_no: null, // 编辑的id
      programtype: [], // 小程序类型
      attachmentsarrs: [], // 数据数组(要传的)
      ids: null,
      loading: false,
      dialogVisiblewecaht: false,
      push_method: 1,
      tihuan: [{ value: '111' }, { value: '222' }],
      show: false,
      newContent: [],
      messageload: false,
      target_employee_no: '',
      alletype: null,
      rid: ''
    }
  },
  created() {
    this.alletype = this.$route.query.type
    this.rid = this.$route.query.item.id
    this.target_employee_no = this.$route.query.item.target_employee_no
    this.title = this.$route.query.item.title
    console.log('this.$route.query.type', this.$route.query.item)
    this.$route.query.item.up_miniprograms.forEach((item, index) => {
      this.attachments.push({
        msgtype: 'miniprogram',
        miniprogram: { app_id: '', des_1: item.des_1, miniprogram_no: item.miniprogram_no, miniprogram_title: '', page: '', recent_reading_page: '', source_material_id: '', thumburl: item.thumburl, title: item.title, weappiconurl: item.weappiconurl }
      })
    })
    // const res = window.JSON.parse(window.localStorage.getItem('massageStorage') || '{}')
    // // eslint-disable-next-line eqeqeq
    // if (this.$route.query.type == 1) {
    //   if (Object.keys(res).length !== 0) {
    //     console.log(11111112222, res)
    //     this.title = res.title
    //     this.content = res.content
    //     this.rand_title = res.rand_title
    //     this.title_options = res.title_options
    //     // this.attachmentsarrs = res.attachmentsarrs
    //     this.attachments = res.attachments
    //     this.push_method = res.push_method
    //     this.sp_message_no = res.sp_message_no
    //   }
    // }

    // this.getmptypeslist()
    // this.type = this.$route.query.type
    // console.log(this.$route.query.type)
    // // eslint-disable-next-line eqeqeq
    // if (this.$route.query.type == 1) {
    //   console.log('新增')
    // } else {
    //   this.ids = this.$route.query.sp_message_no
    //   this.detail()
    // }
  },
  mounted() {},
  beforeDestroy() {
    // // eslint-disable-next-line eqeqeq
    // if (this.type == 1) {
    //   if (!this.messageload) {
    //     const data = {
    //       title: this.title,
    //       content: this.content,
    //       rand_title: this.rand_title,
    //       title_options: this.title_options,
    //       // attachmentsarrs: this.attachmentsarrs,
    //       attachments: this.attachments,
    //       push_method: this.push_method,
    //       sp_message_no: this.sp_message_no
    //     }
    //     window.localStorage.setItem('massageStorage', JSON.stringify(data))
    //   } else {
    //     window.localStorage.removeItem('massageStorage')
    //   }
    // }
  },
  methods: {
    dialogtype(type, index) {
      if (type === 'image') {
        if (this.attachments[index].image) {
          console.log('有image')
        } else {
          this.attachments[index].image = {}
          this.attachments[index].image.source_material_id = ''
          this.attachments[index].image.pic_url = ''
          // delete this.attachments[index].link
          // delete this.attachments[index].miniprogram
        }
      } else if (type === 'link') {
        if (this.attachments[index].link) {
          console.log('有link')
        } else {
          this.attachments[index].link = {}
          this.attachments[index].link.title = ''
          this.attachments[index].link.picurl = ''
          this.attachments[index].link.source_material_id = ''
          this.attachments[index].link.desc = ''
          this.attachments[index].link.url = ''
          this.attachments[index].link.rand_title = 0
          this.attachments[index].link.title_options = []
          this.attachments[index].link.rand_desc = 0
          this.attachments[index].link.desc_options = []
          this.attachments[index].link.replace_link = 1
          // delete this.attachments[index].image
          // delete this.attachments[index].miniprogram
        }
      } else if (type === 'miniprogram') {
        if (this.attachments[index].miniprogram) {
          console.log('有miniprogram')
        } else {
          this.attachments[index].miniprogram = {}
          this.attachments[index].miniprogram.title = ''
          this.attachments[index].miniprogram.source_material_id = ''
          this.attachments[index].miniprogram.app_id = ''
          this.attachments[index].miniprogram.page = ''
          // this.attachments[index].miniprogram.pic_media_src = ''
          // delete this.attachments[index].image
          // delete this.attachments[index].link
        }
      } else {
        if (this.attachments[index].sp_miniprogram) {
          console.log('有sp_miniprogram')
        } else {
          this.attachments[index].sp_miniprogram = {}
          this.attachments[index].sp_miniprogram.app_id = ''
          this.attachments[index].sp_miniprogram.des_1 = ''
          this.attachments[index].sp_miniprogram.pagepath = ''
          this.attachments[index].sp_miniprogram.title = ''
          this.attachments[index].sp_miniprogram.weappiconurl = ''
          this.attachments[index].sp_miniprogram.miniprogram_no = ''
          this.attachments[index].sp_miniprogram.thumburl = ''
        }
      }
    },
    dialogtyper(type, index) {
      if (type === '') {
        this.$message.error('请选择要编辑的类型')
        return
      }
      if (type === null) {
        this.$message.error('请选择要编辑的类型')
        return
      }
      console.log('type', type)
      this.activetype = type
      this.activeindex = index
      if (type === 'image') {
        this.dialogVisibletwo = true
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.mychild.parentHandleclick('1')
        }, 100)
      } else if (type === 'link') {
        console.log(this.attachments[index].link.title)
        this.dialogVisibletu = true
        if (this.attachments[index].link.title === '') {
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send({})
          }, 100)
        } else {
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send(this.attachments[index].link)
          }, 100)
        }
      } else if (type === 'miniprogram') {
        this.dialogVisiblewechat = true
        // if (this.attachments[index].miniprogram.title === '') {
        //   setTimeout(() => {
        //     // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        //     this.$refs.wecahtview.send(this.attachments[index].miniprogram, this.type, this.ids)
        //   }, 100)
        // } else {
        //   setTimeout(() => {
        //     // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        //     console.log('this.attachments[index].miniprogram', this.attachments[index].miniprogram, this.ids)
        //     this.$refs.wecahtview.send(this.attachments[index].miniprogram, this.type, this.ids)
        //   }, 100)
        // }
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.wecahtview.send(this.attachments[index].miniprogram, this.type, this.ids)
        }, 100)
      } else {
        this.dialogVisiblewecaht = true
        setTimeout(() => {
          // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.wechatview.send()
        }, 100)
      }
    },
    add() {
      this.attachments.push({
        msgtype: 'miniprogram',
        miniprogram: { app_id: '', des_1: '', miniprogram_no: '', miniprogram_title: '', page: '', recent_reading_page: '', source_material_id: '', thumburl: '', title: '', weappiconurl: '' }
      })
      // this.newContent = this.tihuan.slice()
      // this.newContent.unshift(this.content)

      console.log('this.newContent', this.newContent)
    },
    deleter(index) {
      this.attachments.splice(index, 1)
    },
    async onclick() {
      console.log('this.attachments', this.attachments)
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.target_employee_no === '') {
        this.$message.error('请输入目标员工ID')
        return
      }

      // if (this.attachments.length === 0) {
      //   if (this.content === '' || this.content === null) {
      //     this.$message.error('内容和附件不能同时为空')
      //     return
      //   }
      // }
      // this.newContent = this.tihuan.slice()
      // this.newContent.unshift(this.content)

      // console.log('this.newContent', this.newContent)
      // const msgtypebool = this.attachments.every((item, index, array) => {
      //   return item.msgtype
      // })
      // if (msgtypebool === false) {
      //   this.$message.error('请选择类型')
      //   return
      // }
      // if (this.rand_title === 1 && this.content !== '') {
      //   if (this.title_options.length === 0) {
      //     this.$message.error(`请完善要编辑替换的内容`)
      //     return
      //   }
      //   for (let i = 0; i < this.title_options.length; i++) {
      //     if (this.title_options[i] === '') {
      //       this.$message.error(`请完善要编辑替换的内容`)
      //       return
      //     }
      //   }
      // }
      // if (this.rand_title === 1 && this.content !== '') {
      //   if (this.title_options.length === 0) {
      //     this.$message.error(`请完善要编辑替换的内容`)
      //     return
      //   }
      //   for (let i = 0; i < this.title_options.length; i++) {
      //     if (this.title_options[i] === '') {
      //       this.$message.error(`请完善要编辑替换的内容`)
      //       return
      //     }
      //   }
      // }
      // if (this.title_options.length !== 0) {
      //   for (let i = 0; i < this.title_options.length; i++) {
      //     if (this.title_options[i] === '') {
      //       this.$message.error(`请完善要编辑替换的内容`)
      //       return
      //     }
      //   }
      // }

      // for (let i = 0; i < this.attachments.length; i++) {
      //   if (this.attachments[i].msgtype) {
      //     this.$message.error(`请选择第${i + 1}条消息类型`)
      //     return
      //   }
      // }
      // const arrs = []
      // this.attachments.forEach((item) => {
      //   if (item.msgtype === 'miniprogram') {
      //     arrs.push({
      //       app_id: item.miniprogram.app_id,
      //       page: item.miniprogram.page,
      //       pic_media_src: item.miniprogram.pic_media_src,
      //       source_material_id: item.miniprogram.source_material_id,
      //       title: item.miniprogram.title
      //     })
      //   }
      // })
      // const routinetypebool = arrs.every((item, index, array) => {
      //   return item.app_id !== ''
      // })
      // if (routinetypebool === false) {
      //   this.$message.error('请完善要编辑的小程序附件')
      //   return
      // }

      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].msgtype === 'miniprogram') {
          if (this.attachments[i].miniprogram.miniprogram_no === '') {
            this.$message.error(`请完善要编辑的第${i + 1}条消息小程序附件`)
            return
          }
        }
      }
      // for (let i = 0; i < this.attachments.length; i++) {
      //   if (this.attachments[i].msgtype === 'sp_miniprogram') {
      //     if (this.attachments[i].sp_miniprogram.app_id === '') {
      //       this.$message.error(`请完善要编辑的第${i + 1}条消息小程序附件`)
      //       return
      //     }
      //   }
      // }

      // for (let i = 0; i < this.attachments.length; i++) {
      //   if (this.attachments[i].msgtype === 'link') {
      //     if (this.attachments[i].link.title === '') {
      //       this.$message.error(`请完善要编辑的第${i + 1}条消息图文附件`)
      //       return
      //     }
      //   }
      // }

      // for (let i = 0; i < this.attachments.length; i++) {
      //   if (this.attachments[i].msgtype === 'image') {
      //     if (this.attachments[i].image.pic_url === '') {
      //       this.$message.error(`请完善要编辑的第${i + 1}条消息图片附件`)
      //       return
      //     }
      //   }
      // }
      console.log(' this.attachments', this.attachments)
      this.attachmentsarrs = []
      this.attachmentsarrs = this.attachments.map(item => {
        return item.miniprogram.miniprogram_no
      })
      // eslint-disable-next-line eqeqeq
      if (this.alletype == 1) {
        rwematerialTaskcreate({
          up_miniprogram_nos: this.attachmentsarrs,
          title: this.title,
          target_employee_no: this.target_employee_no
        }).then((res) => {
          console.log('res', res)
          this.$router.go(-1)
        })
      } else {
        console.log('编辑')
        rwematerialTaskupdate({
          up_miniprogram_nos: this.attachmentsarrs,
          title: this.title,
          target_employee_no: this.target_employee_no,
          id: this.rid
        }).then((res) => {
          console.log('res', res)
          this.$router.go(-1)
        })
      }

      // this.attachments.forEach((item, index) => {
      //   if (item.msgtype === 'miniprogram') {
      //     console.log(item.miniprogram, 'miniprogram-----------------------')
      //     this.attachmentsarrs.push({
      //       msgtype: 'miniprogram',
      //       miniprogram: item.miniprogram
      //     })
      //   }
      //   if (item.msgtype === 'link') {
      //     this.attachmentsarrs.push({
      //       msgtype: 'link',
      //       link: item.link
      //     })
      //   }
      //   if (item.msgtype === 'image') {
      //     this.attachmentsarrs.push({
      //       msgtype: 'image',
      //       image: item.image
      //     })
      //   }
      //   if (item.msgtype === 'sp_miniprogram') {
      //     this.attachmentsarrs.push({
      //       msgtype: 'sp_miniprogram',
      //       sp_miniprogram: item.sp_miniprogram
      //     })
      //   }
      // })
      // if (this.type === 1 || this.type === 3) {
      //   if (this.content === '' && this.rand_title === 1) {
      //     this.$confirm('随机内容为空是否提交, 是否继续?', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       closeOnClickModal: false,
      //       type: 'warning'
      //     })
      //       .then(() => {
      //         spMessage({
      //           title: this.title,
      //           content: this.content,
      //           rand_title: this.rand_title,
      //           title_options: this.title_options,
      //           attachments: this.attachmentsarrs,
      //           push_method: this.push_method
      //         }).then(res => {
      //           this.$router.go(-1)
      //         })
      //       })
      //       .catch(() => {
      //         // this.$message({
      //         //   type: 'info',
      //         //   message: '已取消删除'
      //         // })
      //       })
      //   } else {
      //     const data = await spMessage({
      //       title: this.title,
      //       content: this.content,
      //       rand_title: this.rand_title,
      //       title_options: this.title_options,
      //       attachments: this.attachmentsarrs,
      //       push_method: this.push_method
      //     })
      //     this.$router.go(-1)
      //     // this.$emit('updata')
      //     console.log('data', data)
      //   }
      // } else {
      //   if (this.content === '' && this.rand_title === 1) {
      //     this.$confirm('随机内容为空是否提交, 是否继续?', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       closeOnClickModal: false,
      //       type: 'warning'
      //     })
      //       .then(() => {
      //         spMessagelistupdata({
      //           title: this.title,
      //           content: this.content,
      //           rand_title: this.rand_title,
      //           title_options: this.title_options,
      //           attachments: this.attachmentsarrs,
      //           sp_message_no: this.sp_message_no
      //         }).then(res => {
      //           this.$router.go(-1)
      //         })
      //       })
      //       .catch(() => {
      //         // this.$message({
      //         //   type: 'info',
      //         //   message: '已取消删除'
      //         // })
      //       })
      //   } else {
      //     const data = await spMessagelistupdata({
      //       title: this.title,
      //       content: this.content,
      //       rand_title: this.rand_title,
      //       title_options: this.title_options,
      //       attachments: this.attachmentsarrs,
      //       sp_message_no: this.sp_message_no
      //     })
      //     this.$router.go(-1)
      //     // this.$emit('updata')
      //     console.log('data', data)
      //   }
      // }
      this.messageload = true
    },
    clickicon(img, key) {
      if (this.activetype === 'image') {
        this.dialogVisibletwo = false
        this.attachments[this.activeindex].image.source_material_id = key
        this.attachments[this.activeindex].image.pic_url = img
      }
    },
    callback(form, rand_title, title_options, rand_desc, desc_options, replace_link) {
      if (this.activetype === 'link') {
        console.log('111')
        this.dialogVisibletu = false
        this.attachments[this.activeindex].link.title = form.title
        this.attachments[this.activeindex].link.picurl = form.testsrc
        this.attachments[this.activeindex].link.source_material_id = form.source_material_id
        this.attachments[this.activeindex].link.desc = form.description
        this.attachments[this.activeindex].link.url = form.url
        this.attachments[this.activeindex].link.rand_title = rand_title
        this.attachments[this.activeindex].link.title_options = title_options

        this.attachments[this.activeindex].link.rand_desc = rand_desc
        this.attachments[this.activeindex].link.desc_options = desc_options
        this.attachments[this.activeindex].link.replace_link = replace_link
      }
    },
    callwechat(form) {
      if (this.activetype === 'miniprogram') {
        this.dialogVisiblewechat = false
        console.log('form---', form)
        // this.attachments[this.activeindex].miniprogram.title = form.name
        // this.attachments[this.activeindex].miniprogram.source_material_id = form.sourceMaterialId
        // this.attachments[this.activeindex].miniprogram.app_id = form.app_id
        // this.attachments[this.activeindex].miniprogram.page = form.link
        // this.attachments[this.activeindex].miniprogram.pic_media_src = form.programimg
        this.attachments[this.activeindex].miniprogram.app_id = form.app_id
        this.attachments[this.activeindex].miniprogram.des_1 = form.des_1
        // this.attachments[this.activeindex].miniprogram.pagepath = form.pagepath
        this.attachments[this.activeindex].miniprogram.page = form.pagepath
        this.attachments[this.activeindex].miniprogram.title = form.title
        this.attachments[this.activeindex].miniprogram.weappiconurl = form.weappiconurl
        this.attachments[this.activeindex].miniprogram.miniprogram_no = form.miniprogram_no
        this.attachments[this.activeindex].miniprogram.thumburl = form.thumburl
        this.attachments[this.activeindex].miniprogram.miniprogram_title = form.miniprogram_title
        this.attachments[this.activeindex].miniprogram.source_material_id = form.source_material_id
        this.attachments[this.activeindex].miniprogram.recent_reading_page = form.recent_reading_page
      }
    },
    wechatcallback(form) {
      if (this.activetype === 'sp_miniprogram') {
        this.dialogVisiblewecaht = false
        console.log('form', form)
        this.attachments[this.activeindex].sp_miniprogram.app_id = form.app_id
        this.attachments[this.activeindex].sp_miniprogram.des_1 = form.des_1
        this.attachments[this.activeindex].sp_miniprogram.pagepath = form.pagepath
        this.attachments[this.activeindex].sp_miniprogram.title = form.title
        this.attachments[this.activeindex].sp_miniprogram.weappiconurl = form.weappiconurl
        this.attachments[this.activeindex].sp_miniprogram.miniprogram_no = form.miniprogram_no
        this.attachments[this.activeindex].sp_miniprogram.thumburl = form.thumburl
        this.attachments[this.activeindex].sp_miniprogram.source_material_id = form.source_material_id
      }
    },
    opens(type, item) {
      this.getmptypeslist()
      this.type = type
      if (type === 1) {
        console.log('新增')
        // this.attachments = item.attachments
      } else {
        console.log(item)
        this.ids = item.sp_message_no
        this.detail()
      }
    },
    async detail() {
      this.loading = true
      const data = await sprEnterprise({
        sp_message_no: this.ids
      })
      // eslint-disable-next-line eqeqeq
      const bool = JSON.stringify(data.data) == '{}'
      console.log(bool) // 返回true
      // eslint-disable-next-line eqeqeq
      if (bool == false) {
        this.attachments = []
        this.title = data.data.title
        this.content = data.data.content === null ? '' : data.data.content
        this.rand_title = data.data.rand_title
        this.title_options = data.data.title_options
        this.attachments = data.data.attachments
        this.sp_message_no = data.data.sp_message_no
        this.push_method = data.data.push_method
        this.loading = false
        console.log('data', data)
      } else {
        this.loading = false
        this.$message.error('内容格式错误')
      }
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    find(id) {
      console.log('id', id)
      const indexs = this.programtype.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.mini_program_type == id
      })
      if (indexs === -1) {
        return ''
      } else {
        return this.programtype[indexs].type_name
      }
    },
    sendcahaer(val) {
      if (val === 1) {
        console.log('attachments1', this.attachments)
        this.attachments.forEach(item => {
          if (item.msgtype !== '') {
            item.msgtype = ''
          }
        })
      } else {
        console.log('attachments2', this.attachments)
        this.attachments.forEach(item => {
          if (item.msgtype !== '') {
            item.msgtype = ''
          }
        })
      }
    },
    changewr(item, index) {
      console.log(item)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      if (item.link.rand_title === 1) {
        getMultiTitles({
          text: item.link.title
        }).then(res => {
          console.log('111', res)
          item.link.title_options = res.data
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        })
      } else {
        item.link.title_options = []
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    changewrr(item) {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      if (item.link.rand_desc === 1) {
        getMultiTitles({
          text: item.link.desc
        }).then(res => {
          console.log('222', res)
          item.link.desc_options = res.data
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        })
      } else {
        item.link.desc_options = []
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    changewrrr() {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      if (this.rand_title === 1) {
        getMultiTitles({
          text: this.content
        })
          .then(res => {
            console.log('111', res)
            this.title_options = res.data
            this.$nextTick(() => {
              this.$forceUpdate()
            })
          })
          .catch(() => {
            this.title_options = []
            this.$nextTick(() => {
              this.$forceUpdate()
            })
          })
      } else {
        this.title_options = []
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    contneer() {
      if (this.rand_title === 1) {
        getMultiTitles({
          text: this.content
        })
          .then(res => {
            console.log('111', res)
            this.title_options = res.data
            this.$nextTick(() => {
              this.$forceUpdate()
            })
          })
          .catch(() => {
            this.title_options = []
          })
      }
    },
    deater(index) {
      this.title_options.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.within_box {
  width: 190px;
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
  margin-left: 44px;
  margin-top: 15px;
}
.title_boxr {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 157px;
}
.imaetext {
  display: flex;
  justify-content: space-between;
}
.se_top {
  margin-top: 14px;
}
.describe_text {
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.mincard {
  width: 223px;
  height: 263px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0px 0px 44px;
}
.mincard_title {
  font-size: 12px;
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgrbox {
  width: 100%;
  height: 155px;
}
.line {
  width: 100%;
  height: 1px;
  background: #999999;
  margin: 5px 0px;
}
.bottomwr {
  display: flex;
  align-items: center;
}
.mincard_enjoy {
  margin-bottom: 5px;
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.weadar {
  margin-left: 2px;
  font-size: 12px;
}
.all_box {
  margin: 8px 0px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.onebox {
  display: flex;
  align-items: center;
}
.edit_box {
  padding: 30px;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 80px;
  height: 80px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  line-height: 80px;
  margin: 20px 0px 0px 50px;
}
.oneboxs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.boxs {
  position: relative;
  font-size: 22px;
  margin-bottom: 20px;
}
.del {
  text-align: center;
  position: absolute;
  top: -12px;
  right: 8px;
}
.item-cell-box{
  margin: 10px 26px
}
.add-btn{
   margin-left: 80px;margin-bottom: 20px;
}
@media (max-width: 768px){
  .edit_box{
    padding:5vw;
  }
  .all_box{
    height:auto;
    overflow:auto;
    max-height:none;
  }
  .item-cell-box{
    margin: 3vw 0px;
  }
  .add-btn{
    width:100%;
    height:8vw;
    margin-left: 0vw;margin-bottom: 2vw;
  }
  .confirm-button{
    width:100%;
    height:8vw;
  }
}
</style>
